import { inject, Injectable } from '@angular/core';
import { ConfirmationModalService } from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { config } from '@core/interfaces/api_baseurl';
import { BehaviorSubject, of, switchMap } from 'rxjs';
import { CategoryComponent } from '../category.component';
import { TicketingService } from '@page/ticketing/helper/ticketing.service';
import { RequestType } from '@page/ticketing/helper/ticket.interface';
import { ApiService } from '@core/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private _requestType$ = new BehaviorSubject<RequestType | null>(null);
  private _confirmationModalService = inject(ConfirmationModalService);
  private _ApiService = inject(ApiService);
  private _ticketingService = inject(TicketingService);

  serviceId!: number;

  get requestType(): RequestType | null {
    return this._requestType$.value;

  }

  set requestType(value: RequestType | null) {
    this._requestType$.next(value);
  }

  /** Opens category selection modal */
  openCategory(): void {

    this._confirmationModalService.init(CategoryComponent, { data: { source: this._ticketingService.raiseTicketData?.source ?? false } });
  }

  /** Fetches request types and opens the category modal */
  fetchRequestType(): void {
    if (this.requestType) {
      this.openCategory();
      return;
    }

    this._ApiService.post(config.ticketing.raise.request_type)
      .pipe(
        switchMap((res: any) => this.handleApiResponse(res, 'No Issue type found..!'))
      )
      .subscribe();
  }

  /** Fetches transaction issue types based on transaction details */
  fetchTxnIssueType(txnDetails: { ref_id: string; txn_status: string }): void {
    const requestData = {
      ref_id: txnDetails.ref_id,
      service: this.serviceId,
      txn_status: txnDetails.txn_status,
    };
    this._ticketingService.updateRaiseTicketData = {
      txn_ref_id: txnDetails.ref_id,
      service_id: this.serviceId,
      txn_status: +txnDetails.txn_status,
      support_type_id: 2
    };
    this._ApiService.post(config.ticketing.raise.txn_issues, requestData)
      .pipe(
        switchMap((res: any) => this.handleApiResponse(res, res.message))
      )
      .subscribe();
  }

  /** Handles API responses and opens the category modal */
  private handleApiResponse(response: any, errorMessage: string) {
    if (!response?.data?.length) {
      this._confirmationModalService.openSubmitConfirmationModal('', 'error', errorMessage);
      return of(null);
    }

    this.requestType = response.data;
    this.openCategory();
    return of(response);
  }
}
